// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Loader_wrapperComponent__AZLYo","spinner":"Loader_spinner__3V9+e"};